import React, { Component } from 'react';

class IconSidebarItemChatbot extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                data-name="Layer 1"
                viewBox="0 0 500 500"
                width="24"
                height="24"
                >
                <path
                    fill={this.props.isActive ? "#26A" : "#424242"}
                    stroke={this.props.isActive ? "#26A" : "#424242"}
                    d="M439 303.9v-77q0-51.7-.1-103.4c-.1-34.1-27.7-61.9-61.7-61.9q-127-.3-254.3-.1a62.1 62.1 0 00-61.8 61.8q-.1 92.6.1 185.1a64.2 64.2 0 003.3 19.8c8.7 25.5 32.1 42.1 59.5 42.1h221.1a3.9 3.9 0 013.4 1.3c18.7 18.9 37.6 37.8 56.4 56.6l5.1 5.2c4.2 4.1 8.5 6.2 12.9 6.2a16.4 16.4 0 006.4-1.4c6.5-3 9.7-8.6 9.7-16.8-.1-39.2-.1-78.4 0-117.5zm-32.1 58.8v22l-6.3-6.3-33.9-34a20.2 20.2 0 00-15-6.3H125.1c-13.9 0-23.3-5.6-28.6-17.1a33.7 33.7 0 01-3.2-14q-.3-88.5-.1-177.1v-5.1c0-15 8.3-26 22.8-30.1a32.5 32.5 0 018.7-1h250.6c15.3 0 26.4 8.4 30.4 22.9a30.3 30.3 0 011.1 8.3q.1 118.9.1 237.8z"
                    className="cls-1"
                />
            </svg>
        );
    }
}

export default IconSidebarItemChatbot;